export const SITE_URL = "https://baoson.cn";

export const SITE_NAME = "瓜料动态";

export const SITE_SLOGAN = "今日更新不停档 · 实时吃瓜不迷路";

export const SITE_EMAIL = "hello@gualiaodongtai.com";

export const NAV_LINKS = [
  { label: "首页", to: "/" },
  { label: "热搜榜", to: "/#hot" },
  { label: "常见问题", to: "/faq" },
  { label: "关于我们", to: "/about" },
];